import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { type ReactElement } from "react";
import { useHistory } from "react-router-dom";

import { AuthFormContent, AuthMode, useAuthMode } from "../libs";

export function SwitchAuthMode(): ReactElement {
  const { authFormContent, authMode } = useAuthMode();
  const history = useHistory();

  return (
    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" pb={6}>
      <Text semibold sx={{ color: (theme) => theme.palette.text.secondary }}>
        {authFormContent[AuthFormContent.SWITCH_AUTH_MODE_INSTRUCTIONS]}{" "}
      </Text>
      <TextButton
        size="large"
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.SWITCH_BETWEEN_LOGIN_SIGNUP, {
            from: authMode,
            to: authMode === AuthMode.LOGIN ? AuthMode.SIGN_UP : AuthMode.LOGIN,
          });
          history.push({
            pathname: authMode === AuthMode.LOGIN ? AuthMode.SIGN_UP : AuthMode.LOGIN,
            state: history.location.state,
          });
        }}
      >
        <Text semibold sx={(theme) => ({ color: theme.palette.link?.primary })}>
          {authFormContent[AuthFormContent.SWITCH_AUTH_MODE_CTA]}
        </Text>
      </TextButton>
    </Stack>
  );
}
